import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgToledo(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="3 -4 18 24" {...props}>
      <path
        d="M13.175 4.21v1.387H9.17c-.166 0-.458.209-.51.367l-.792 2.408h8.165l-.24-.724 1.36-.336.245.73c.06.182.22.44.357.575l.449.448c.383.383.695 1.315.695 2.08v4.162a.694.694 0 01-.695.693h-1.39a.694.694 0 01-.695-.693v-.694H7.78v.694a.694.694 0 01-.695.693h-1.39A.694.694 0 015 15.307v-4.161c0-.766.311-1.698.695-2.081l.449-.448c.135-.136.293-.393.354-.574l.842-2.516C7.582 4.8 8.4 4.21 9.17 4.21zm3.638 5.895a1.39 1.39 0 00-1.39 1.387 1.39 1.39 0 002.78 0 1.39 1.39 0 00-1.39-1.387zm-9.728 0c-.768 0-1.39.622-1.39 1.387a1.39 1.39 0 002.78 0 1.39 1.39 0 00-1.39-1.387zM12.5 6.4c.276 0 .5.239.5.533 0 .295-.224.534-.5.534h-1c-.276 0-.5-.24-.5-.534s.224-.533.5-.533zm1.493-2.19c1.138 0 2.175.706 2.703 1.728l.19.573-1.008.25c-.232-.85-1.08-1.468-1.885-1.468V4.211zm0-2.045c2.321 0 4.28 1.591 4.89 3.756l.053.198-1.033.258c-.416-1.733-1.913-3.04-3.722-3.124l-.188-.005zm0-2.165c3.315 0 6.108 2.289 6.952 5.393l.055.213-1.032.257c-.642-2.67-2.964-4.678-5.76-4.776l-.215-.004z"
        fill="currentColor"
      />
    </svg>
  );
}

export default tombacIcon('Toledo')(SvgToledo);
